import HubSpotBot from "components/Chatbot/Chatbot";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import MyRouter from "routers/index";
import IdleOverlay from "components/IdleOverlay";

function App() {
  return (
    <div className="bg-white text-base dark:bg-[#333333] text-neutral-900 dark:text-neutral-200">
      {/* <HubSpotBot/> */}
      <BrowserRouter>
        {/* <IdleOverlay /> */}
        <MyRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;